import React, { Component } from 'react';

import serverClientUtil from '../../../../../utils/serverClientUtil';
import commonUtil from '../../../../../utils/commonUtil';
import * as defaultConst from '../../../../../utils/clientConstant';

const applicationRoutes = commonUtil.getApplicationRoutes();

class OtherStores extends Component {
  getDisplayStyle = (brand) => {
    if (brand === commonUtil.getBrand()) {
      return 'hide';
    }
    return '';
  };

  render() {
    const props = this.props;
    const labels = props.labels;
    const eventId = props.eventId;

    const lpGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.LP) + commonUtil.getRouteByParameter(applicationRoutes.giftListGuestView, { eventID: eventId });

    const wsGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.WS) + commonUtil.getRouteByParameter(applicationRoutes.giftListGuestView, { eventID: eventId });

    const pbGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.PB) + commonUtil.getRouteByParameter(applicationRoutes.giftListGuestView, { eventID: eventId });

    const gapGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.GAP) + commonUtil.getRouteByParameter(applicationRoutes.giftListGuestView, { eventID: eventId });

    const pbkGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.PBK) + commonUtil.getRouteByParameter(applicationRoutes.giftListGuestView, { eventID: eventId });

    const weGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.WLM) + commonUtil.getRouteByParameter(applicationRoutes.giftListGuestView, { eventID: eventId });

    const truGRURL = serverClientUtil.getMultiSiteURL(defaultConst.constBrand.TRU) + commonUtil.getRouteByParameter(applicationRoutes.giftListGuestView, { eventID: eventId });

    return (
      <div className="col-xs-12">
        <div className="otherStores">
          <p>{commonUtil.getLabel(labels.GuestviewPage, 'guestview.brand.selction.text')}</p>
          <div style={{ textAlign: 'center' }}>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={lpGRURL}
              className={this.getDisplayStyle(defaultConst.constBrand.LP)}
            >
              <img src={commonUtil.getAssetURL() + '/images/admin/lvLogo.png'} alt="Liverpool" />
            </a>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={wsGRURL}
              className={this.getDisplayStyle(defaultConst.constBrand.WS)}
            >
              <img src={commonUtil.getAssetURL() + '/images/admin/wsLogo.png'} alt="Williams Sonoma" />
            </a>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={pbGRURL}
              className={this.getDisplayStyle(defaultConst.constBrand.PB)}
            >
              <img src={commonUtil.getAssetURL() + '/images/admin/pbLogo.png'} alt="Potery Barn" />
            </a>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={pbkGRURL}
              className={this.getDisplayStyle(defaultConst.constBrand.PBK)}
            >
              <img src={commonUtil.getAssetURL() + '/images/admin/pbkLogo.png'} alt="Potery Barn Kids" />
            </a>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={gapGRURL}
              className={this.getDisplayStyle(defaultConst.constBrand.GAP)}
            >
              <img src={commonUtil.getAssetURL() + '/images/admin/gapLogo.png'} alt="Potery Barn Teen" />
            </a>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={weGRURL}
              className={this.getDisplayStyle(defaultConst.constBrand.WLM)}
            >
              <img src={commonUtil.getAssetURL() + '/images/admin/whLogo.png'} alt="West Elm" />
            </a>
            {
              serverClientUtil.enableIconToys &&
              <a
                rel="noopener noreferrer"
                target="_blank"
                href={truGRURL}
                className={this.getDisplayStyle(defaultConst.constBrand.TRU)}
              >
                <img src={commonUtil.getAssetURL() + '/images/admin/truLogo.png'} alt="Toys R Us" />
              </a>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default OtherStores;
